export default __webpack_public_path__ + "static/media/four__ball.6a698551.svg";